import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GotoSignIn, SignOut } from '../session';
import { SetAuthenticationContext } from './auth-context.actions';
import { AuthContextStateModel } from './model/auth-context-state-model';
import { AuthenticationContext } from './model/authentication-context';

const DEFAULT_STATE: AuthContextStateModel = {
  authenticationContext: 'SIGN_IN'
};

@State<AuthContextStateModel>({
  name: 'authContext',
  defaults: DEFAULT_STATE
})
@Injectable()
export class AuthContextState {
  @Selector()
  static authenticationContext(state: AuthContextStateModel): AuthenticationContext {
    return state.authenticationContext;
  }

  @Action(SignOut)
  @Action(GotoSignIn)
  resetAuthContext(ctx: StateContext<AuthContextStateModel>): void {
    ctx.patchState({ authenticationContext: 'SIGN_UP' });
  }

  @Action(SetAuthenticationContext)
  setAuthFormEmail(ctx: StateContext<AuthContextStateModel>, { authenticationContext }: SetAuthenticationContext): void {
    ctx.patchState({
      authenticationContext
    });
  }
}
